import { BsInfoCircleFill } from 'react-icons/bs'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
  PopoverBody,
  PopoverArrow,
  IconButton,
  Link,
  Code,
} from '@chakra-ui/react'
import type { PlacementWithLogical } from '@chakra-ui/react'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { colors } from '../../../ui-kit'

interface Props {
  placement?: PlacementWithLogical
  info: string
  link?: string
  hyperlink?: string
}

export const InfoPopover = ({
  placement,
  info,
  link,
  hyperlink,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Popover trigger="hover" placement={placement}>
      <PopoverTrigger>
        <IconButton
          aria-label="Info icon"
          icon={<BsInfoCircleFill />}
          color={colors.appBlueyGrey}
          size="sm"
          variant="link"
        />
      </PopoverTrigger>
      <PopoverContent>
        <PopoverArrow />
        <PopoverBody>
          <Trans t={t} i18nKey={info}>
            <Code></Code>
          </Trans>
          {link && hyperlink && (
            <Link href={link} isExternal lineHeight="base">
              {' '}
              {hyperlink}
            </Link>
          )}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  )
}
